import { render, staticRenderFns } from "./TransferTable.vue?vue&type=template&id=57584d1e&scoped=true"
import script from "./TransferTable.vue?vue&type=script&lang=js"
export * from "./TransferTable.vue?vue&type=script&lang=js"
import style0 from "./TransferTable.vue?vue&type=style&index=0&id=57584d1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57584d1e",
  null
  
)

export default component.exports